export default __webpack_public_path__ + "a366aba80fa03fda41086810efdaed96.svg";